import React from 'react'
import { connect } from 'react-redux'
import { Box } from '@chakra-ui/react'

import UsageCard from '_components/UsageCard'

function AccountResources({ appUsage }) {
  const { keywords, domains, competitors, keywordFinder, serpChecker, backlinkChecker, difficulty } = appUsage
  const domainsLabel = `${domains.used} ${domains.used > 1 ? 'domains' : 'domain'}`
  return (
    <Box>
      <UsageCard title={'Keywords'} limit={keywords.limit} used={keywords.used} />
      <UsageCard
        title={`Competitors (${domainsLabel})`}
        limit={competitors.limit * domains.used}
        used={competitors.used}
      />
      <UsageCard
        title={'Monthly keywords lookups'}
        limit={keywordFinder.limit}
        used={keywordFinder.used}
      />
      <UsageCard title={'Monthly SERP lookups'} limit={serpChecker.limit} used={serpChecker.used} />
      <UsageCard
        title={'Monthly Difficulty checks'}
        limit={difficulty.limit}
        used={difficulty.used}
      />
      <UsageCard
        title={'Monthly Backlink rows'}
        limit={backlinkChecker.limit}
        used={backlinkChecker.used}
      />
    </Box>
  )
}

const mapStateToProps = state => {
  return {
    appUsage: state.appUsage
  }
}

export default connect(mapStateToProps)(AccountResources)
